<template>
    <div v-if="isShown" class="cs3-trial-waiting">
       <span class="cs3-trial-waiting-text">{{dictionaryFile.pleaseWait}}</span>
       <div class="cs3-trial-timer-container">
      <div class="cs3-trial-timer" id="cs3-trial-timer" init-counter="60"></div>
       </div> 
      <span class="cs3-trial-waiting-text" v-html="dictionaryFile.additionalInformationWhileWaiting"></span>
    </div>
</template>

<script>

export default {
    name: "WaitingTimer",
    emits: [ "waitIsFinishing", "waitFinished"],
    props: {
        isShown: {
            type: Boolean,
            required: true
        },
        dictionaryFile: {
            type: Object,
            required: true
        }
    },
    data: function(){
      return{
        isFirstUpdate: true
      }
    },
    methods: {

    },
    updated: function(){
        if(this.isFirstUpdate){
          this.isFirstUpdate = false;
          let timer = null;
          setTimeout(()=> {timer = document.getElementById('cs3-trial-timer')});
          for(let i = 0; i < 60; i++){
              setTimeout( ()=>{timer.setAttribute('init-counter', 60-i)}, 1000* i+1);
          }
          setTimeout(()=>{this.$emit('waitIsFinishing')}, 50000);
          setTimeout(()=> {this.$emit('waitFinished')},60000);
        }
        
    }
}
</script>


<style scoped>
.cs3-trial-timer-container {
    position: relative;
    display: flex;
    height: 100px;
    justify-content: center;
    align-items: center;
    margin: 15px 0;
  }
  .cs3-trial-timer {
    width: 100px;
    height: 100px;
    box-shadow: 0 0 0 2.5px, inset 5px 5px 10px rgba(0, 0, 0, 0.125), 5px 5px 10px rgba(0, 0, 0, 0.125);
    font-size: 45px;
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #60CF70;
    border-radius: 50%;
    font-weight: 500;
    overflow: hidden;
    transform: translateZ(0);
  }
  
  .cs3-trial-timer::before {
    content: attr(init-counter);
    -webkit-animation: 1s 0.875s 60 timer_beat;
            animation: 1s 0.875s 60 timer_beat;
  }
  @-webkit-keyframes timer_beat {
    40%, 80% {
      transform: none;
    }
    50% {
      transform: scale(1.125);
    }
  }
  @keyframes timer_beat {
    40%, 80% {
      transform: none;
    }
    50% {
      transform: scale(1.125);
    }
  }
  
  .cs3-trial-timer::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(105, 207, 96, 0.3);
    -webkit-animation: 60s 1s linear forwards timer_indicator;
            animation: 60s 1s linear forwards timer_indicator;
  }
  @-webkit-keyframes timer_indicator {
    100% {
      transform: translateY(100%);
    }
  }
  @keyframes timer_indicator {
    100% {
      transform: translateY(100%);
    }
  }
  
  .cs3-trial-waiting {
    font-size: 13px;
    padding-bottom: 15px;
  }
  
  .cs3-trial-waiting-text {
    padding: 0 15px;
    display: block;
  }
</style>